import React from 'react';
import ChartScatter from '../Chart/ChartScatter';
import ChatBar from '../Chart/ChatBar';

const TextoIntermedio = React.memo(function TextoIntermedio({
  texto,
  dataChart,
  currentAnswer,
  indiceGrupoActual,
  textoPosicionY,
  textoPosicionX,
}) {
  return (
    <>
      {indiceGrupoActual !== 0 &&
        Array.isArray(dataChart) &&
        dataChart.length > 0 && (
          <>
            {indiceGrupoActual === 1 ? (
              <ChatBar
                indiceGrupoActual={indiceGrupoActual}
                textoPosicionY={textoPosicionY}
                textoPosicionX={textoPosicionX}
                currentAnswer={currentAnswer}
                dataChart={dataChart}
              />
            ) : (
              <ChartScatter
                textoPosicionY={textoPosicionY}
                textoPosicionX={textoPosicionX}
                dataChart={dataChart}
                currentAnswer={currentAnswer}
                indiceGrupoActual={indiceGrupoActual}
                textoIntermedio={texto}
              />
            )}
          </>
        )}
      <div dangerouslySetInnerHTML={{ __html: texto }} />
    </>
  );
});

export default TextoIntermedio;
